import React from 'react';
import { Container, Col, Row, Card, CardBody } from 'reactstrap';
import BreadCrumb from '../../Components/Common/BreadCrumb';
import { getAuthToken } from '../../auth/tokenvalidation';
import WidgetStatus from './WidgetStatus';
import WidgetStatusMitra from './WidgetStatusMitra';
import BarChart from './BarChart';
import { useSelector } from 'react-redux';
import './dashboard.css';

const Dashboard = () => {
  document.title = 'Dashboard';

  const { user } = useSelector(state => state.Login);
  const userRoles = user?.role?.split(',').map(r => r.trim()) || [];
  const token = getAuthToken();

  const hasDMUTAccess = userRoles.includes('DMUT');
  const hasBarChartAccess =
    userRoles.includes('Product Trading') || userRoles.includes('Super Admin');

  return (
    <React.Fragment>
      <div className='page-content'>
        <Container fluid>
          <BreadCrumb title='Dashboard' pageTitle='Tasks' />
          <Row>
            <Col xxl={12} className='mb-3'>
              {hasBarChartAccess && <WidgetStatus token={token} />}
            </Col>
            <Col xxl={12} className='mb-3'>
              {hasDMUTAccess && <WidgetStatusMitra token={token} />}
            </Col>
            <Col xxl={12}>
              {hasBarChartAccess && <BarChart token={token} />}
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default Dashboard;
